import { CrudView } from '@westernmilling/react_component_library';

import ItemForm from 'components/Forms/OttoUpdateView';

export default class OttoUpdateViewContainer extends CrudView {
  constructor(props) {
    super(props);
    this.state.section = this.getSection();
  }

  getSection = () => (
    {
      type: 'otto_updates',
      form: ItemForm,
      title: '',
      listRoute: '../../',
      listLabel: 'Otto Updates List',
      edit_admins: [],
    }
  );
}
